import { Observable, Observer } from 'windowed-observable';

declare global {
  interface Window {
    bearerToken?: string;
  }
}

/**
 * Defines the type of function that triggers refreshment of the bearer token.
 */
export type BearerTokenRefreshTrigger = () => Promise<void>;

/**
 * Bearer token info.
 */
export type BearerTokenInfo = {
  idToken: string;
  extExpiresOn?: Date;
  expiresOn?: Date | null;
  refresh?: BearerTokenRefreshTrigger;
};

const bearerTokenObservable = new Observable<BearerTokenInfo | undefined>(
  'bearer-token'
);

/**
 * Get current token from observable (if it has been set.)
 * @returns an instance of {@link BearerTokenInfo} or undefined.
 */
export const getCurrentBearerToken = () => bearerTokenObservable.getLastEvent();

/**
 * Function to publish token into the observable.
 * @param tokenInfo {@link BearerTokenInfo} to set
 * @returns void
 */
export const setBearerToken = (tokenInfo: BearerTokenInfo) =>
  bearerTokenObservable.publish(tokenInfo);

/**
 * Subscribes an observer.
 * @param observer an {@link Observer}
 * @returns a void cleanup function to unsubscribe.
 */
export const subscribe = (observer: Observer) => {
  bearerTokenObservable.subscribe(observer);

  const cleanup = () => bearerTokenObservable.unsubscribe(observer);

  return cleanup;
};
